const CHUNK_LOAD_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /loading chunk [\w-]+ failed/i,
];

export function isChunkLoadError(error: unknown): boolean {
  if (!error) {
    return false;
  }
  if (error instanceof Error && error.name === 'ChunkLoadError') {
    return true;
  }
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

export const CHUNK_RELOAD_STORAGE_KEY = 'by-chunk-reload-at';
export const CHUNK_RELOAD_COOLDOWN_MS = 30_000;

export function canReloadAfterChunkError(
  lastReloadAt: number | null,
  now: number,
): boolean {
  return lastReloadAt === null || now - lastReloadAt > CHUNK_RELOAD_COOLDOWN_MS;
}
